import axios from "axios";

const runtimeApi = typeof window !== "undefined" ? window.DIGITALIS_CONFIG?.apiBase : "";
const backendUrl = process.env.REACT_APP_BACKEND_URL || "";
export const API = runtimeApi || `${backendUrl}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("digitalis-token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Terjadi kesalahan. Coba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}
